module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABD0lEQVQ4jc3UO0oEQRSF4W8GX2AooqCRJqIuQgTxGeg2NDRwD+auw0DwgSgYGJhMpm5AMTBSUBNlpKAGaqpbBtsZ8ER961b/HO653TXbTZlGcYIRzOMtv5CqedBe95XALiPopaTfUfUfYK9YjtBKwBT2gS3c/BbWAuawjVhXUgjlAovx5Xc8V4XhOgALMf9F9W7C9AKY79kXjvCAVUxn/Ud8ZmeDGC8Dhlmu4yzWAzjEWqyvsJA7Cl9Kbcc9ZsSUW6GcRlepZnHbweEQxsocPhUnUlihiZI7bUqBSxjOfgabyXPY0fMSRgh2Bf25w0kcYy+GEmD7Sf8OuzG4VGHWc5iSzbAr+v+L3RNgo2s0Gt+ekTlg7A4OVAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/7006/window_radio_name.png
// module id = g/At
// module chunks = 1